import React from 'react';
import { Badge, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import NavLink from '../components/NavLink';
import { Guardian } from '@xaamin/guardian';

const AccountSidebar = ({ live, openConfig, onMenuItemClick, onOpenConfigRequest }) => {
  return (
    <div className="sidebar-container-alt">
      <div className="scrollbar">
        <Nav
          defaultActiveKey="/cuenta"
          className="flex-column"
        >
          <Nav.Link
            as={NavLink}
            eventKey="go-dashboard"
            to="/app/dashboard"
            className="go-to-dashboard"
            onClick={onMenuItemClick}
          >
            <FontAwesomeIcon
              icon={['fas', 'arrow-left']}
              className="mr-2"
            />
            <span className="nav-link-text">DASHBOARD</span>
          </Nav.Link>

          <Nav.Link
            eventKey="disabled"
            disabled
            className="divider-simple"
          ></Nav.Link>

          {!live && (
            <Nav.Link
              as={NavLink}
              eventKey="into"
              to="/app/intro"
              onClick={onMenuItemClick}
            >
              <FontAwesomeIcon icon={['fas', 'rocket']} />
              <span className="nav-link-text">
                INTRO
                <Badge
                  variant="info"
                  className="beta-badge"
                >
                  COMPLETAR
                </Badge>
              </span>
            </Nav.Link>
          )}

          {Guardian.allows('perfil.listar') && (
            <Nav.Link
              as={NavLink}
              eventKey="perfil"
              to="/cuenta/perfil"
              onClick={onMenuItemClick}
            >
              <FontAwesomeIcon icon={['far', 'id-card']} />
              <span className="nav-link-text">Mi Perfil</span>
            </Nav.Link>
          )}

          <Nav.Link
            as="div"
            to="/cuenta/config/activacion"
            onClick={onOpenConfigRequest}
          >
            <FontAwesomeIcon icon={['fas', 'check-double']} />
            <span className="nav-link-text">Mi cuenta</span>
            <FontAwesomeIcon
              icon={['fas', 'chevron-right']}
              className="float-right"
            />
          </Nav.Link>

          {openConfig && (
            <Nav
              defaultActiveKey="activate"
              className="flex-column config-collapse"
            >
              {Guardian.allows('cuenta.activar') && (
                <Nav.Link
                  as={NavLink}
                  eventKey="activate"
                  to="/cuenta/config/activacion"
                  onClick={onMenuItemClick}
                >
                  <span className="nav-link-text">Activar cuenta</span>
                </Nav.Link>
              )}
              {/* <Nav.Link as={ NavLink } eventKey="certificates" to="/cuenta/config/certificados" onClick={ onMenuItemClick }>
                  <span className="nav-link-text">
                    Certificados
                  </span>
                  </Nav.Link> */}
              {Guardian.allows('cuenta.informacion.fiscal') && (
                <Nav.Link
                  as={NavLink}
                  eventKey="billing-info"
                  to="/cuenta/config/informacion-de-facturacion"
                  onClick={onMenuItemClick}
                >
                  <span className="nav-link-text">Información fiscal</span>
                </Nav.Link>
              )}
              {/* <Nav.Link as={ NavLink } eventKey="customization" to="/cuenta/config/personalizar" onClick={ onMenuItemClick }>
                  <span className="nav-link-text">
                    Personalizar
                  </span>
                  </Nav.Link> */}
            </Nav>
          )}

          {Guardian.allows('account.api-keys') && (
            <Nav.Link
              as={NavLink}
              eventKey="dev-keys"
              to="/cuenta/keys"
              onClick={onMenuItemClick}
            >
              <FontAwesomeIcon icon={['fas', 'code']} />
              <span className="nav-link-text">API keys</span>
            </Nav.Link>
          )}

          <Nav.Link
            as={NavLink}
            eventKey="empresas"
            to="/cuenta/empresas"
            onClick={onMenuItemClick}
          >
            <FontAwesomeIcon icon={['far', 'building']} />
            <span className="nav-link-text">Mis empresas</span>
          </Nav.Link>

          {Guardian.allows('hits.asignar') && (
            <Nav.Link
              as={NavLink}
              eventKey="empresas"
              to="/cuenta/preferencias-hits"
              onClick={onMenuItemClick}
            >
              <FontAwesomeIcon icon={['fas', 'cog']} />
              <span className="nav-link-text">Mis hits</span>
            </Nav.Link>
          )}

          {/*
              TODO

              Regresar estos links cuando funcionen
              */}
          {/* <Nav.Link as={ NavLink } eventKey="consumo" to="/cuenta/consumo" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['far', 'chart-bar'] } />
              <span className="nav-link-text">
                Consumo
              </span>
            </Nav.Link>
            <Nav.Link as={ NavLink } eventKey="pago" to="/cuenta/forma-de-pago" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['far', 'credit-card'] } />
              <span className="nav-link-text">
                Forma de Pago
              </span>
            </Nav.Link> */}

          <Nav.Link
            as={NavLink}
            eventKey="compra"
            to="/cuenta/paquetes"
            onClick={onMenuItemClick}
          >
            <FontAwesomeIcon icon={['fas', 'shopping-basket']} />
            <span className="nav-link-text">Paquetes</span>
          </Nav.Link>

          <Nav.Link
            as={NavLink}
            eventKey="historial-compra"
            to="/cuenta/historial-compra"
            onClick={onMenuItemClick}
          >
            <FontAwesomeIcon icon={['far', 'credit-card']} />
            <span className="nav-link-text">Mi consumo</span>
          </Nav.Link>

          {Guardian.allows('sucursal.crear') && (
            <Nav.Link
              as={NavLink}
              eventKey="sucursal"
              to="/cuenta/sucursal"
              onClick={onMenuItemClick}
            >
              <FontAwesomeIcon icon={['far', 'building']} />
              <span className="nav-link-text">Sucursales</span>
            </Nav.Link>
          )}

          <Nav.Link
            as={NavLink}
            eventKey="panel-configuraciones"
            to="/cuenta/panel-configuraciones"
            onClick={onMenuItemClick}
          >
            <FontAwesomeIcon icon={['fas', 'cogs']} />
            <span className="nav-link-text">Configuraciones</span>
          </Nav.Link>

          {/* <Nav.Link as={ NavLink } eventKey="compra" to="/cuenta/comprar" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['fas', 'shopping-basket'] } />
              <span className="nav-link-text">
                Comprar <strong>hits</strong>
              </span>
            </Nav.Link> */}
        </Nav>
      </div>
    </div>
  );
};

export default AccountSidebar;
